import Skeleton from '@mui/material/Skeleton';
import Grid from '@mui/material/GridLegacy';

const ResourceGroupPageSkeleton = () => (
	<Grid
		container
		spacing={2}
		mt={1}
		mb={5}
		role='progressbar'
		aria-label='Loading'
		data-testid='skeletonLoading'
	>
		<Grid item xs={12}>
			<Skeleton variant='rectangle' width='100%' height='24px' />
		</Grid>
		<Grid item xs={12}>
			<Skeleton variant='rectangle' width='100%' height='144px' />
		</Grid>
		<Grid item xs={12}>
			<Skeleton variant='rectangle' width='100%' height='24px' />
		</Grid>
		{[0, 1, 2, 3, 4].map(i => (
			<Grid item xs={12} key={`skeleton-${i}`}>
				<Skeleton variant='rectangle' width='100%' height='48px' />
			</Grid>
		))}
	</Grid>
);

export default ResourceGroupPageSkeleton;
